// Hostnames that mean "this is local development", not real user traffic.
//
// The dev server runs on local.bytbostad.se (see devServer.host in
// vue.config.js), so checking only for 'localhost' silently misses every
// local session and lets dev noise into production telemetry.
var DEV_HOSTNAMES = [
  'localhost',
  '127.0.0.1',
  'local.bytbostad.se',
]

export function isDevHost () {
  var hostname = (typeof window !== 'undefined' &&
                  window.location &&
                  window.location.hostname) || ''
  return DEV_HOSTNAMES.indexOf(hostname) !== -1
}
